const PropTypes = require('prop-types');
const React = require('react');
const CSRFForm = require('components/shared/csrf_form.jsx');
const { UserStore } = require('@reverbdotcom/discovery-ui');

class AddToCartButton extends React.Component {
  renderAidInput() {
    if (!this.props.aid) { return null; }

    return (
      <input
        type="hidden"
        name="_aid"
        value={this.props.aid}
      />
    );
  }

  render() {
    if (!this.props.productId) { return null; }

    return (
      <CSRFForm method="POST" action="/cart" className="add-to-cart">
        <input
          type="hidden"
          name="cart_item[action_source_attributes][device]"
          value={UserStore.getState().deviceType}
        />
        <input
          type="hidden"
          name="cart_item[product_id]"
          value={this.props.productId}
        />
        {this.props.suggestedListing &&
          <input
            type="hidden"
            name="cart_item[suggested_listing]"
            value={this.props.suggestedListing}
          />
        }
        {this.renderAidInput()}
        <input
          type="submit"
          value={I18n.t('productShowPage.addToCart')}
          className={this.props.className}
        />
      </CSRFForm>
    );
  }
}

AddToCartButton.propTypes = {
  productId: PropTypes.number,
  className: PropTypes.string,
  aid: PropTypes.string,
  suggestedListing: PropTypes.bool,
};

module.exports = AddToCartButton;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/add_to_cart_button.jsx